<template>
  <CContainer fluid>
    <h3>Consultas Contables</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-3">
            <label class="col-12 text-muted font-weight-bold">
              Fecha Inicial:
            </label>
            <Datepicker 
              class="col-12"
              type="date" 
              v-model="fechaInicial" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY"
              placeholder="dd/mm/aaaa" />
          </CCol>
          <CCol col="sm-3">
            <label class="col-sm-12 text-muted font-weight-bold">Fecha Final</label>
            <Datepicker 
              class="col-12"
              type="date" 
              v-model="fechaFinal" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY"
              placeholder="dd/mm/aaaa" />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
        <CRow class="mt-3">
          <CCol col="12" sm="12" md="12" lg="6">
            <div class="metro-menu">
              <div 
                class="tile small bg-info"
                @click="downloadReportProductPUC($event)">
                <!-- <i class="bi bi-table h4"></i> -->
                <i class="bi bi-box-seam h4"></i>
                <span>PUC Productos</span>
              </div>
              <div 
                class="tile small bg-dark"
                @click="downloadReportKitCosts($event)">
                <i class="bi bi-boxes h4"></i>
                <span>Costos KITs</span>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <LoadingCover v-show="loading" />
  </CContainer>
</template>

<script>
  import moment from "moment";
  import Datepicker from "vue2-datepicker";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { downloadFileObject, downloadBase64File } from "@/api";
  import { 
    descargarCostosVentaProductosKitExcel,
    descargaConfiguracionContableProductosExcel
  } from "@/apiReports"

  export default {
    name: "AccountingMenu",
    components: {
      Datepicker,
      LoadingCover
    },
    data() {
      return {
        loading: false,
        fechaInicial: "",
        fechaFinal: ""
      }
    },
    methods: {
      moment,
      async downloadReportProductPUC(e) {
        e.preventDefault();
        e.stopPropagation();

        this.loading = true;

        try {
          const parametros = {
            "Fecha_Inicial": this.fechaInicial,
            "Fecha_Final": this.fechaFinal
          }

          const { response } = await descargaConfiguracionContableProductosExcel(this, parametros);
          const { nombreArchivo, contenidoArchivo } = response;

          downloadBase64File("vnd.ms-excel", contenidoArchivo, nombreArchivo);
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error al cargar los datos. Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      async downloadReportKitCosts(e) {
        e.preventDefault();
        e.stopPropagation();

        this.loading = true;

        try {
          const parametros = {
            "Fecha_Inicial": this.fechaInicial,
            "Fecha_Final": this.fechaFinal
          }

          const { response } = await descargarCostosVentaProductosKitExcel(this, parametros);
          const { nombreArchivo, contenidoArchivo } = response;

          downloadFileObject(nombreArchivo, "vnd.ms-excel", contenidoArchivo);
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error al cargar los datos. Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>
